var _defs, _g, _g2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgClaimConfirmed = function SvgClaimConfirmed(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cfdcff;}.cls-2{fill:#ffd066;}.cls-3{fill:#4e4c4d;}.cls-4{fill:#263238;}.cls-5{fill:#ebebeb;}.cls-6{fill:#f5f5f5;}.cls-7{fill:#fff;}.cls-8{fill:#5e80e6;}.cls-9{fill:#dbdbdb;}.cls-10{fill:#c7c7c7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    "data-name": "Background Simple"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.74,414.91H504.52a219.11,219.11,0,0,0,55-44.71c50.74-57.27,69.39-154.1,43.34-225.91l-2.4-5.17c-19.28-41.56-59.71-70.29-105.89-73.66a125.82,125.82,0,0,0-19.51.08c-43.29,3.57-83.86,30.08-104,68-11.85,22.28-17.68,48.91-37,65.38-25.1,21.43-62.73,17.54-95.62,12.46s-70.55-8.88-95.55,12.66c-15.66,13.49-22.72,34.55-24.12,55C115.08,332.51,146.7,384.68,191.74,414.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.55,94.58A5.38,5.38,0,0,1,173.84,97l1.26,2.47a45.76,45.76,0,0,1,20.55-2.68,6.74,6.74,0,0,1,6.11,3.68,6.93,6.93,0,0,1-3.15,9.37,7.23,7.23,0,0,1-3.88.71,45.54,45.54,0,0,0-14.08.94l11,21.56c19.25-4.41,30-1.27,36.15,10.74,6.28,12.36.79,25.47-12.79,34.08l3.43,6.73a5.39,5.39,0,0,1-2.37,7.29,5.49,5.49,0,0,1-7.4-2.32l-3.54-7a54.43,54.43,0,0,1-27.49,3,6.92,6.92,0,0,1-5.77-3.85,6.83,6.83,0,0,1,3-9.32,6.9,6.9,0,0,1,4.33-.65c7.22,1.14,13.7,1.09,20.45-.93L188.4,148.65c-18.57,4.07-29.35,1.78-35.81-10.91-6.11-12-.79-25.19,12.68-33.46l-1.2-2.35A5.5,5.5,0,0,1,166.55,94.58Zm15,40.59-10.11-19.88c-6.85,4.33-8.5,10-6,14.92C167.85,134.92,171.46,136.76,181.54,135.17Zm16.82,11.1,10.39,20.44c6.79-4.44,8.9-10,6.15-15.43C212.39,146.34,208.38,144.56,198.36,146.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.16,85.25a2,2,0,0,1,.65,2.78l-.54.87a17,17,0,0,1,4.84,6,2.5,2.5,0,0,1,0,2.65,2.57,2.57,0,0,1-3.59.82,2.68,2.68,0,0,1-1-1.09,16.91,16.91,0,0,0-3-4.29l-4.72,7.66c5.14,5.26,6.23,9.29,3.6,13.56s-7.93,5.2-13.3,2.55l-1.47,2.4a2,2,0,0,1-2.78.66,2,2,0,0,1-.7-2.8l1.53-2.48a20.29,20.29,0,0,1-6.27-8.15,2.59,2.59,0,0,1,.1-2.58,2.55,2.55,0,0,1,3.55-.85,2.58,2.58,0,0,1,1.05,1.26,16.6,16.6,0,0,0,4.26,6.31l4.84-7.87c-4.89-5.1-6.25-9-3.48-13.48,2.63-4.28,7.85-5.14,13.08-2.47l.52-.83A2,2,0,0,1,273.16,85.25Zm-10,12.63,4.36-7.06c-2.71-1.34-4.82-.77-5.9,1S260.71,95,263.17,97.88Zm-.26,7.49-4.48,7.27c2.73,1.3,4.92.88,6.1-1C265.61,109.85,265.39,108.23,262.91,105.37Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 175.89,
    y: 156.3,
    width: 384.52,
    height: 254.28,
    rx: 14.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.86,394.16H577.46a0,0,0,0,1,0,0v4.45a17.8,17.8,0,0,1-17.8,17.8h-381a17.8,17.8,0,0,1-17.8-17.8v-4.45a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 186.21,
    y: 166.4,
    width: 362.8,
    height: 214.73
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "330.25 391.77 335.41 400 408.16 400 412.96 391.77 330.25 391.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 193.69,
    y: 173.67,
    width: 348.6,
    height: 206.78,
    rx: 3.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "541.91 380.75 193.31 380.75 193.69 189.13 541.91 189.13 541.91 380.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.28,181.66a2.79,2.79,0,1,1-2.79-2.78A2.78,2.78,0,0,1,222.28,181.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.4,181.66a2.79,2.79,0,1,1-2.78-2.78A2.77,2.77,0,0,1,205.4,181.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M213.5,181.66a2.79,2.79,0,1,1-2.78-2.78A2.77,2.77,0,0,1,213.5,181.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M557.1,391.77c0,.14-85.34.25-190.59.25s-190.62-.11-190.62-.25,85.33-.25,190.62-.25S557.1,391.64,557.1,391.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 287.83,
    y: 337.62,
    width: 158.44,
    height: 2.23,
    rx: 1.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 287.83,
    y: 344.54,
    width: 158.44,
    height: 2.23,
    rx: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 326.36,
    cy: 361.23,
    r: 7.32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "326.48 365.5 322.11 361.08 323.58 359.64 326.13 362.21 331.42 353.92 333.16 355.02 326.48 365.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344.69,361.17a4.42,4.42,0,0,1,.28-1.55,4.3,4.3,0,0,1,.82-1.36,4.19,4.19,0,0,1,1.32-1,4,4,0,0,1,1.78-.37,3.9,3.9,0,0,1,2,.51,3.38,3.38,0,0,1,1.28,1.35l-1.27.87a2.26,2.26,0,0,0-.41-.6,1.73,1.73,0,0,0-.52-.39,2,2,0,0,0-.57-.21,2.44,2.44,0,0,0-.59-.07,2.34,2.34,0,0,0-1.09.25,2.46,2.46,0,0,0-.77.66,3.12,3.12,0,0,0-.46.91,3.58,3.58,0,0,0-.15,1,3.32,3.32,0,0,0,.18,1.09,2.94,2.94,0,0,0,.51.92,2.56,2.56,0,0,0,.79.63,2.15,2.15,0,0,0,1,.24,2.58,2.58,0,0,0,.6-.07,2.19,2.19,0,0,0,.6-.23,2.13,2.13,0,0,0,.52-.4,1.71,1.71,0,0,0,.38-.59l1.36.78a2.58,2.58,0,0,1-.58.84,3.77,3.77,0,0,1-.86.62,4.23,4.23,0,0,1-1,.39,4.88,4.88,0,0,1-1.06.13,3.56,3.56,0,0,1-1.66-.39,4.31,4.31,0,0,1-1.31-1,4.86,4.86,0,0,1-.85-1.4A4.49,4.49,0,0,1,344.69,361.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357,365.55a3.93,3.93,0,0,1-1.7-.37,4.11,4.11,0,0,1-1.31-1,4.6,4.6,0,0,1-.85-1.39,4.36,4.36,0,0,1,0-3.23,4.51,4.51,0,0,1,.88-1.38,4.2,4.2,0,0,1,1.32-.95,3.91,3.91,0,0,1,1.67-.35,3.77,3.77,0,0,1,1.69.37,4.44,4.44,0,0,1,1.3,1,4.62,4.62,0,0,1,.84,1.4,4.34,4.34,0,0,1,.3,1.58,4.3,4.3,0,0,1-.31,1.63,4.39,4.39,0,0,1-.87,1.36,4.08,4.08,0,0,1-3,1.31Zm-2.48-4.32a3.46,3.46,0,0,0,.17,1.06,2.9,2.9,0,0,0,.49.92,2.41,2.41,0,0,0,.78.63,2.44,2.44,0,0,0,2.11,0,2.5,2.5,0,0,0,.78-.66,3,3,0,0,0,.48-.92,3.31,3.31,0,0,0,.16-1,3.47,3.47,0,0,0-.17-1.07,2.94,2.94,0,0,0-.49-.91,2.36,2.36,0,0,0-.78-.63,2.24,2.24,0,0,0-1-.24,2.2,2.2,0,0,0-1.07.25,2.34,2.34,0,0,0-.78.65,2.63,2.63,0,0,0-.47.91A3.33,3.33,0,0,0,354.51,361.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,360v5.46h-1.66V357h1.29l4.44,5.59V357h1.65v8.51h-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.58,365.49V357h5.72v1.45h-4.07v2.19h3.39V362h-3.39v3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.47,365.49V357h1.65v8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.9,365.49V357h3.77a2.44,2.44,0,0,1,1.08.24,2.9,2.9,0,0,1,1.42,1.56,2.67,2.67,0,0,1,.21,1,2.78,2.78,0,0,1-.42,1.5,2.32,2.32,0,0,1-1.12,1l2,3.21h-1.86l-1.74-2.86h-1.64v2.86Zm1.65-4.31h2.08a1,1,0,0,0,.43-.11,1.17,1.17,0,0,0,.34-.29,1.83,1.83,0,0,0,.23-.44,1.91,1.91,0,0,0,.08-.54,1.38,1.38,0,0,0-.1-.55,1.44,1.44,0,0,0-.25-.44,1.17,1.17,0,0,0-.38-.29.92.92,0,0,0-.42-.1h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.83,365.49v-5.64l-2.2,4.2h-.9l-2.2-4.2v5.64h-1.65V357h1.77l2.52,4.84,2.55-4.84h1.76v8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M406.17,364v1.46h-5.91V357h5.81v1.45h-4.16v2.05h3.59v1.34h-3.59V364Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M407.47,365.49V357h3.1a4.74,4.74,0,0,1,1.83.33,3.89,3.89,0,0,1,1.31.91,3.82,3.82,0,0,1,.79,1.35,5,5,0,0,1,.26,1.65,4.89,4.89,0,0,1-.29,1.76,3.81,3.81,0,0,1-.84,1.35,3.77,3.77,0,0,1-1.33.86,4.76,4.76,0,0,1-1.73.31Zm5.63-4.28a3.65,3.65,0,0,0-.17-1.12,2.56,2.56,0,0,0-.49-.89,2.23,2.23,0,0,0-.8-.58,2.79,2.79,0,0,0-1.07-.2h-1.44V364h1.44a2.63,2.63,0,0,0,1.08-.21,2.16,2.16,0,0,0,.79-.6,2.49,2.49,0,0,0,.49-.89A3.65,3.65,0,0,0,413.1,361.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 318.39,
    y: 196.13,
    width: 100.42,
    height: 128.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 318.39,
    y: 203.33,
    width: 100.42,
    height: 7.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "318.39 210.82 373.2 210.82 368.6 218.89 318.39 218.89 318.39 210.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "318.39 201.84 373.2 201.84 370.94 204.81 318.39 204.81 318.39 201.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "318.39 206.23 347.68 206.23 345.42 209.2 318.39 209.2 318.39 206.23"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 327.58,
    y: 248.64,
    width: 82.04,
    height: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 327.58,
    y: 242.33,
    width: 82.04,
    height: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 327.58,
    y: 254.95,
    width: 82.04,
    height: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 327.58,
    y: 261.26,
    width: 82.04,
    height: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 327.58,
    y: 267.57,
    width: 82.04,
    height: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 327.58,
    y: 273.87,
    width: 82.04,
    height: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 327.58,
    y: 280.18,
    width: 82.04,
    height: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 352.18,
    y: 286.49,
    width: 57.44,
    height: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 327.58,
    y: 242.33,
    width: 24.6,
    height: 44.16
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "327.58 254.95 368.6 254.87 409.62 254.95 368.6 255.03 327.58 254.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "327.58 261.26 368.6 261.18 409.62 261.26 368.6 261.34 327.58 261.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "327.58 267.56 368.6 267.49 409.62 267.56 368.6 267.64 327.58 267.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "327.58 273.87 368.6 273.79 409.62 273.87 368.6 273.95 327.58 273.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "327.58 280.18 368.6 280.1 409.62 280.18 368.6 280.26 327.58 280.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "327.58 286.49 368.6 286.41 409.62 286.49 368.6 286.57 327.58 286.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M332,245.49c2.62-.14,5.24-.14,7.86-.16s5.24,0,7.86.16c-2.62.13-5.24.14-7.86.16S334.59,245.62,332,245.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M332,251.79c2-.13,4-.14,5.95-.15s4,0,5.94.15c-2,.14-4,.15-5.94.16S334,251.93,332,251.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M332,258.1c2.62-.13,5.24-.14,7.86-.16s5.24,0,7.86.16c-2.62.14-5.24.14-7.86.16S334.59,258.23,332,258.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M332,264.41c2.16-.13,4.32-.14,6.47-.16s4.32,0,6.47.16c-2.15.13-4.31.14-6.47.16S334.13,264.54,332,264.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M332,270.72c2.62-.13,5.24-.14,7.86-.16s5.24,0,7.86.16c-2.62.13-5.24.14-7.86.16S334.59,270.85,332,270.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M332,277c2.62-.13,5.24-.14,7.86-.16s5.24,0,7.86.16c-2.62.13-5.24.14-7.86.16S334.59,277.16,332,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M332,283.34c1.59-.13,3.19-.16,4.78-.16s3.18,0,4.77.16c-1.59.12-3.18.15-4.77.16S333.56,283.46,332,283.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M357.93,245.49c2-.14,3.93-.14,5.9-.16s3.94,0,5.91.16c-2,.13-3.94.14-5.91.16S359.9,245.62,357.93,245.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M357.93,251.79c2-.13,3.93-.14,5.9-.15s3.94,0,5.91.15c-2,.14-3.94.15-5.91.16S359.9,251.93,357.93,251.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M357.93,258.1c2-.13,3.93-.14,5.9-.16s3.94,0,5.91.16c-2,.14-3.94.14-5.91.16S359.9,258.23,357.93,258.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M357.93,264.41c2-.13,3.93-.14,5.9-.16s3.94,0,5.91.16c-2,.13-3.94.14-5.91.16S359.9,264.54,357.93,264.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M357.93,270.72c2-.13,3.93-.14,5.9-.16s3.94,0,5.91.16c-2,.13-3.94.14-5.91.16S359.9,270.85,357.93,270.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M357.93,277c2-.13,3.93-.14,5.9-.16s3.94,0,5.91.16c-2,.13-3.94.14-5.91.16S359.9,277.16,357.93,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M357.93,283.34c2-.14,3.93-.14,5.9-.16s3.94,0,5.91.16c-2,.13-3.94.14-5.91.16S359.9,283.47,357.93,283.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M375,245.49c2-.14,3.93-.14,5.9-.16s3.94,0,5.91.16c-2,.13-3.94.14-5.91.16S377,245.62,375,245.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379,283.34a11.24,11.24,0,0,1,3.78,0,11.24,11.24,0,0,1-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379,277a11.24,11.24,0,0,1,3.78,0,11.24,11.24,0,0,1-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379,270.72a11,11,0,0,1,1.89-.16,10.05,10.05,0,0,1,1.89.16,11.24,11.24,0,0,1-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379,264.41a11.24,11.24,0,0,1,3.78,0,11.24,11.24,0,0,1-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379,258.1a11.24,11.24,0,0,1,3.78,0,11.24,11.24,0,0,1-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379,251.79a12,12,0,0,1,3.78,0,11.24,11.24,0,0,1-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M380.13,289.64c1.12-.12,2.23-.15,3.34-.16s2.22,0,3.34.16a34.94,34.94,0,0,1-6.68,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M392.06,245.49c2-.14,3.94-.14,5.91-.16s3.94,0,5.91.16c-2,.13-3.94.14-5.91.16S394,245.62,392.06,245.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M392.06,251.79c2-.13,3.94-.14,5.91-.15s3.94,0,5.91.15c-2,.14-3.94.15-5.91.16S394,251.93,392.06,251.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M392.06,258.1c2-.13,3.94-.14,5.91-.16s3.94,0,5.91.16c-2,.14-3.94.14-5.91.16S394,258.23,392.06,258.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M392.06,264.41c2-.13,3.94-.14,5.91-.16s3.94,0,5.91.16c-2,.13-3.94.14-5.91.16S394,264.54,392.06,264.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M392.06,270.72c2-.13,3.94-.14,5.91-.16s3.94,0,5.91.16c-2,.13-3.94.14-5.91.16S394,270.85,392.06,270.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M392.06,277c2-.13,3.94-.14,5.91-.16s3.94,0,5.91.16c-2,.13-3.94.14-5.91.16S394,277.16,392.06,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M392.06,283.34c2-.14,3.94-.14,5.91-.16s3.94,0,5.91.16c-2,.13-3.94.14-5.91.16S394,283.47,392.06,283.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M392.06,289.64c2-.13,3.94-.14,5.91-.16s3.94,0,5.91.16c-2,.14-3.94.14-5.91.16S394,289.78,392.06,289.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M327.58,215.49c2.44-.13,4.87-.19,7.3-.24s4.87-.05,7.31-.08,4.87,0,7.3.08l3.65.08c1.22.06,2.44.09,3.65.16-1.21.07-2.43.1-3.65.16l-3.65.09c-2.43,0-4.87,0-7.3.07s-4.87,0-7.31-.08S330,215.62,327.58,215.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M327.58,212.38c2.77-.13,5.53-.19,8.29-.25s5.53,0,8.3-.07,5.53,0,8.29.07l4.15.09c1.38.06,2.76.09,4.15.16-1.39.07-2.77.1-4.15.16l-4.15.08c-2.76,0-5.53,0-8.29.08s-5.53,0-8.3-.08S330.35,212.51,327.58,212.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.58,231.2c2.26-.09,4.53-.14,6.79-.18s4.53,0,6.79-.05,4.53,0,6.79.05,4.53.08,6.79.18c-2.26.1-4.52.15-6.79.19s-4.52,0-6.79.05-4.53,0-6.79-.05S329.84,231.3,327.58,231.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.58,233.89c1.42-.1,2.84-.14,4.26-.18s2.84,0,4.26-.06,2.84,0,4.26.06,2.84.08,4.26.18c-1.42.1-2.84.15-4.26.19s-2.84,0-4.26,0-2.84,0-4.26-.06S329,234,327.58,233.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.58,236.58c2-.1,3.95-.15,5.93-.18s3.95,0,5.93-.06,3.95,0,5.93.06,3.95.08,5.92.18c-2,.1-4,.14-5.92.18s-4,0-5.93.06-4,0-5.93-.06S329.56,236.68,327.58,236.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.58,297.67c1.45-.1,2.91-.15,4.36-.18s2.91,0,4.36-.06,2.91,0,4.36.05,2.91.09,4.36.19c-1.45.1-2.91.14-4.36.18s-2.91,0-4.36.06-2.91,0-4.36-.06S329,297.77,327.58,297.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.58,300.36c1.68-.1,3.36-.15,5-.19s3.36,0,5-.05,3.36,0,5,.05,3.36.09,5,.19c-1.68.1-3.36.14-5,.18s-3.36,0-5,.06-3.36,0-5-.06S329.26,300.46,327.58,300.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.58,311.07c2.64-.1,5.28-.14,7.92-.18l7.93-.06,7.92.06c2.64,0,5.28.08,7.92.18-2.64.1-5.28.15-7.92.19l-7.92.05-7.93-.06C332.86,311.22,330.22,311.17,327.58,311.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.58,303c1-.09,2.05-.14,3.08-.18s2-.05,3.07-.06,2,0,3.08.06,2,.08,3.07.18c-1,.1-2.05.15-3.07.19s-2.05,0-3.08,0-2.05,0-3.07,0S328.61,303.14,327.58,303Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379,305.7c2.56-.1,5.11-.15,7.66-.19l7.65-.05,7.65.05c2.55,0,5.1.09,7.65.19-2.55.1-5.1.14-7.65.18l-7.65.06-7.65-.06C384.12,305.84,381.57,305.79,379,305.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379,303c2.08-.09,4.15-.14,6.22-.18s4.14,0,6.21-.06,4.15,0,6.22.06,4.14.08,6.22.18c-2.08.1-4.15.15-6.22.19s-4.14,0-6.22,0-4.14,0-6.21,0S381.09,303.14,379,303Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379,308.38c1.95-.09,3.9-.14,5.85-.18s3.89,0,5.84-.06,3.89,0,5.84.06,3.9.08,5.84.18c-1.94.1-3.89.15-5.84.19s-3.89,0-5.84.05-3.9,0-5.84-.05S381,308.48,379,308.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379,311.07c1.4-.1,2.8-.14,4.19-.18s2.79,0,4.19-.06,2.79,0,4.19.06,2.79.08,4.19.18c-1.4.1-2.8.15-4.19.19s-2.79,0-4.19.05-2.79,0-4.19-.06S380.41,311.17,379,311.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M328.42,308.87c.76-.53,1.54-1,2.34-1.48a11.15,11.15,0,0,1,2.54-1.14,2,2,0,0,1,.35-.07.37.37,0,0,1,.39.13,1.43,1.43,0,0,1,.16.72,8.1,8.1,0,0,1-.15,1.39c-.16.92-.39,1.81-.63,2.71a41.28,41.28,0,0,1-1.85,5.24,8.17,8.17,0,0,1-.65,1.24,2.26,2.26,0,0,1-.25.29.36.36,0,0,1-.24.11.24.24,0,0,1-.17-.06l-.08-.08a1.34,1.34,0,0,1-.2-.74,9.22,9.22,0,0,1,.49-2.77,16.37,16.37,0,0,1,1-2.58,7.89,7.89,0,0,1,1.63-2.27,2.51,2.51,0,0,1,1.28-.61,1.62,1.62,0,0,1,.72.06,1.21,1.21,0,0,1,.51.52,3.24,3.24,0,0,0,.38.56.55.55,0,0,0,.56.18,3.44,3.44,0,0,0,1.16-.68l.56-.41.3-.19a.38.38,0,0,1,.39,0c.18.23.13.47.22.68a.42.42,0,0,0,.48.3,4.23,4.23,0,0,0,1-.89c.32-.33.62-.68.92-1,.61-.7,1.2-1.41,1.82-2.1.31-.34.62-.68,1-1a5.82,5.82,0,0,1,.53-.46,2,2,0,0,1,.31-.19.59.59,0,0,1,.21-.05.26.26,0,0,1,.21.12,1.3,1.3,0,0,1,.1.74q0,.34-.12.69a10.81,10.81,0,0,1-.37,1.35,13.44,13.44,0,0,1-1.1,2.56,2.61,2.61,0,0,1-.44.58.48.48,0,0,1-.4.16,1.26,1.26,0,0,1-.38-.1,1.76,1.76,0,0,1-.93-1.13.64.64,0,0,1,.06-.44.42.42,0,0,1,.18-.17.5.5,0,0,1,.23-.05,2.62,2.62,0,0,1,.72.17c.44.16.87.34,1.29.53l1.27.54a5.47,5.47,0,0,0,.64.23,1.73,1.73,0,0,0,.31.07A.48.48,0,0,0,347,310c.35-.17.58-.6.93-.94a1.06,1.06,0,0,1,.7-.36.32.32,0,0,1,.29.09.38.38,0,0,1,.09.28,2,2,0,0,1-.06.38c-.07.21-.09.47,0,.48s.34,0,.53,0a3.55,3.55,0,0,0,1.17-.61,6.75,6.75,0,0,1,.59-.4,1.15,1.15,0,0,1,.77-.18,2.85,2.85,0,0,1,1.18.86,3.1,3.1,0,0,0,.5.42c.08.06.15.07.17.05a1.58,1.58,0,0,0,.27-.16,9.5,9.5,0,0,0,1-.88,12,12,0,0,0,1.79-2.05,2.3,2.3,0,0,0,.44-1.2c0-.41-.42-.6-.86-.67a7.48,7.48,0,0,0-2.71,0,6.54,6.54,0,0,0-1.31.37,2,2,0,0,0-.58.32c-.18.12-.33.3-.28.46a.85.85,0,0,0,.44.41c.2.1.42.17.63.25a13.18,13.18,0,0,0,1.32.39,30.68,30.68,0,0,0,5.5.52v0a29.31,29.31,0,0,1-5.53-.41c-.46-.1-.9-.23-1.34-.37-.22-.09-.44-.15-.66-.26a1,1,0,0,1-.55-.51.7.7,0,0,1,.34-.69,3.25,3.25,0,0,1,.63-.35,7.11,7.11,0,0,1,1.34-.4,7.58,7.58,0,0,1,2.81-.07,2,2,0,0,1,.7.23.88.88,0,0,1,.4.68,2.59,2.59,0,0,1-.47,1.38,11.31,11.31,0,0,1-1.83,2.13,11.67,11.67,0,0,1-1.07.91,1.69,1.69,0,0,1-.33.19.49.49,0,0,1-.47-.06,3.89,3.89,0,0,1-.56-.48,2.81,2.81,0,0,0-1-.77c-.34-.05-.74.27-1.11.53a4,4,0,0,1-1.27.67,1.07,1.07,0,0,1-.82,0,.53.53,0,0,1-.16-.47,2.88,2.88,0,0,1,.07-.36,1.39,1.39,0,0,0,.06-.31s0,0,0,0h0a.83.83,0,0,0-.5.27c-.31.29-.53.74-1,1a.85.85,0,0,1-.42.08,1.43,1.43,0,0,1-.37-.08,6.42,6.42,0,0,1-.66-.24c-.44-.18-.86-.37-1.28-.56s-.84-.37-1.27-.52a2.18,2.18,0,0,0-.62-.16c-.15,0-.23.12-.19.32a1.48,1.48,0,0,0,.76.94.86.86,0,0,0,.3.09c.06,0,.12,0,.2-.1a2.65,2.65,0,0,0,.4-.52,13.72,13.72,0,0,0,1.12-2.5c.14-.43.28-.88.38-1.32a5.2,5.2,0,0,0,.11-.67,1.13,1.13,0,0,0-.05-.62c-.06-.12-.33,0-.49.15s-.35.29-.52.44c-.33.32-.65.66-1,1-.62.68-1.22,1.38-1.83,2.07l-.93,1a4.35,4.35,0,0,1-1.08.91.52.52,0,0,1-.59-.37c-.09-.21-.08-.49-.2-.62s-.17,0-.27,0a2.68,2.68,0,0,0-.28.18c-.19.13-.37.28-.55.42a3.78,3.78,0,0,1-1.21.72.71.71,0,0,1-.69-.22,3.55,3.55,0,0,1-.41-.57c-.13-.19-.25-.4-.44-.46a1.26,1.26,0,0,0-.64,0,2.31,2.31,0,0,0-1.18.58,7.6,7.6,0,0,0-1.56,2.23,15.87,15.87,0,0,0-1,2.55,9.24,9.24,0,0,0-.45,2.68,1.28,1.28,0,0,0,.14.59l0,0h0l.07,0a1.68,1.68,0,0,0,.19-.24,9.13,9.13,0,0,0,.64-1.2,39.54,39.54,0,0,0,1.88-5.18c.26-.89.5-1.78.67-2.68A7.86,7.86,0,0,0,334,307a1.21,1.21,0,0,0-.12-.62.19.19,0,0,0-.23-.06c-.11,0-.22,0-.33,0a12.76,12.76,0,0,0-2.53,1.08c-.81.44-1.6.91-2.38,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M385,216.23a3.24,3.24,0,0,1,1.16,1.85h-1.48a1.94,1.94,0,0,0-1.89-1.23,1.8,1.8,0,0,0-1,.28,1.91,1.91,0,0,0-.71.8,3.08,3.08,0,0,0,0,2.43,1.91,1.91,0,0,0,.71.8,1.8,1.8,0,0,0,1,.28,1.94,1.94,0,0,0,1.89-1.23h1.48a3.24,3.24,0,0,1-1.16,1.85,3.78,3.78,0,0,1-4,.22,3,3,0,0,1-1.2-1.27,4.35,4.35,0,0,1,0-3.73,3.09,3.09,0,0,1,1.2-1.28,3.47,3.47,0,0,1,1.79-.45A3.42,3.42,0,0,1,385,216.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M389.15,221.6h2.38v1.08h-3.79v-7.06h1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M397.17,221.26h-2.83l-.5,1.42h-1.49l2.59-7h1.62l2.59,7h-1.5Zm-.39-1.07-1-3-1,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M401.82,215.62v7.06H400.4v-7.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M411.2,215.7v7h-1.4v-4.87L408,222.68h-1.22L405,217.83v4.85h-1.41v-7h1.71l2.12,5.25,2.08-5.25Z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClaimConfirmed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Claim_Confirmed.fa44e2e3.svg";
export { ForwardRef as ReactComponent };